import { FadeIn, Overline } from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    n: "01",
    title: "Creator Research and Selection",
    text: "Identify creators based on subject matter, audience fit, channel performance and campaign objectives.",
  },
  {
    n: "02",
    title: "Sponsorship Strategy",
    text: "Help brands determine suitable creator categories, integration formats and campaign structures.",
  },
  {
    n: "03",
    title: "Creator Outreach and Coordination",
    text: "Contact relevant creators, assess interest and coordinate sponsorship discussions.",
  },
  {
    n: "04",
    title: "Campaign Management",
    text: "Coordinate commercial terms, deliverables, timelines and communication between brand and creator.",
  },
  {
    n: "05",
    title: "Performance and Reporting",
    text: "Where data is available, organise campaign performance information and report relevant metrics.",
  },
];

export const Services = () => (
  <section id="services" className="bg-ink text-offwhite py-24 md:py-32 grain relative" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <FadeIn className="max-w-3xl">
        <Overline light>Services</Overline>
        <h2 className="mt-6 font-serif text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight leading-tight text-white">
          YouTube sponsorships, managed <em className="italic text-mutedblue">thoughtfully</em>.
        </h2>
      </FadeIn>

      <div className="mt-16">
        {SERVICES.map((s, i) => (
          <FadeIn key={s.n} delay={i * 0.06}>
            <div
              className="group grid grid-cols-[auto_1fr] md:grid-cols-[80px_1fr_1fr_48px] gap-6 md:gap-10 items-baseline py-8 md:py-10 border-t border-white/10 last:border-b"
              data-testid={`service-row-${s.n}`}
            >
              <span className="font-serif text-sm text-mutedblue">{s.n}</span>
              <h3 className="font-serif text-2xl md:text-3xl tracking-tight text-white group-hover:text-mutedblue transition-colors duration-300">
                {s.title}
              </h3>
              <p className="col-span-2 md:col-span-1 text-sm md:text-base text-offwhite/60 leading-relaxed max-w-lg">
                {s.text}
              </p>
              <ArrowUpRight
                className="hidden md:block h-5 w-5 text-offwhite/40 justify-self-end transition-all duration-300 group-hover:text-mutedblue group-hover:translate-x-1 group-hover:-translate-y-1"
                aria-hidden="true"
              />
            </div>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);
